import { makeStyles } from "@mui/styles";
import { FormControlLabel, Typography, Checkbox } from "@mui/material";
import colors from "../../../common/styles/colors";

type Props = {
  label: string;
  onChange: () => void;
  checked?: boolean;
};

const useStyles = makeStyles({
  container: () => ({
    border: `1px solid ${colors.lightGrey4}`,
    backgroundColor: `${colors.white}`,
    width: "100%",
    borderRadius: 5,
    marginTop: 10
  }),
  checkbox: {
    marginLeft: 10,
    padding: 10
  },
  label: {
    fontSize: 14,
    marginBottom: 1,
    paddingLeft: 2
  }
});

export const CheckboxItem = ({ label, onChange, checked }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FormControlLabel
        sx={{ width: "100%" }}
        value={""}
        onChange={onChange}
        checked={checked}
        control={<Checkbox className={classes.checkbox} size={"small"} />}
        label={<Typography className={classes.label}>{label}</Typography>}
        data-testid="checkbox-item"
      />
    </div>
  );
};
